import { createAction } from 'redux-actions';

const actions = {
  /**
   * [상점 공지사항] 상점 공지사항 데이터 변경하기
   */
  SET_DATA: 'notice/store/SET_DATA',
  setData: createAction('notice/store/SET_DATA'),

  /**
   * [상점 공지사항 리스트] 상점 공지사항 리스트 가져오기
   */
  GET_NOTICE_STORE_LIST_REQUEST: 'notice/store/GET_NOTICE_STORE_LIST_REQUEST',
  GET_NOTICE_STORE_LIST_SUCCESS: 'notice/store/GET_NOTICE_STORE_LIST_SUCCESS',
  getNoticeStoreList: createAction('notice/store/GET_NOTICE_STORE_LIST_REQUEST'),

  /**
   * [상점 공지사항 리스트] 상점 공지사항 리스트 엑셀 다운로드 하기
   */
  GET_NOTICE_STORE_EXCEL_DOWNLOAD_REQUEST: 'notice/store/GET_NOTICE_STORE_EXCEL_DOWNLOAD_REQUEST',
  GET_NOTICE_STORE_EXCEL_DOWNLOAD_SUCCESS: 'notice/store/GET_NOTICE_STORE_EXCEL_DOWNLOAD_SUCCESS',
  getNoticeStoreExcelDownload: createAction('notice/store/GET_NOTICE_STORE_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [상점 공지사항 리스트] 선택된 상점 공지사항 삭제하기
   */
  DELETE_NOTICE_STORE_REQUEST: 'notice/store/DELETE_NOTICE_STORE_LIST_REQUEST',
  DELETE_NOTICE_STORE_SUCCESS: 'notice/store/DELETE_NOTICE_STORE_LIST_SUCCESS',
  deleteNoticeStore: createAction('notice/store/DELETE_NOTICE_STORE_LIST_REQUEST'),

  /**
   * [상점 공지사항 등록] 상점 공지사항 등록시 필요한 정보 가져오기
   */
  PREPARE_ADD_NOTICE_STORE_REQUEST: 'notice/store/PREPARE_ADD_NOTICE_STORE_REQUEST',
  PREPARE_ADD_NOTICE_STORE_SUCCESS: 'notice/store/PREPARE_ADD_NOTICE_STORE_SUCCESS',
  prepareAddNoticeStore: createAction('notice/store/PREPARE_ADD_NOTICE_STORE_REQUEST'),

  /**
   * [상점 공지사항 등록] 상점 공지사항 추가하기
   */
  ADD_NOTICE_STORE_REQUEST: 'notice/store/ADD_NOTICE_STORE_REQUEST',
  ADD_NOTICE_STORE_SUCCESS: 'notice/store/ADD_NOTICE_STORE_SUCCESS',
  addNoticeStore: createAction('notice/store/ADD_NOTICE_STORE_REQUEST'),

  /**
   * [상점 공지사항 편집] 상점 공지사항 요청하기
   */
  GET_NOTICE_STORE_REQUEST: 'notice/store/GET_NOTICE_STORE_REQUEST',
  GET_NOTICE_STORE_SUCCESS: 'notice/store/GET_NOTICE_STORE_SUCCESS',
  getNoticeStore: createAction('notice/store/GET_NOTICE_STORE_REQUEST'),

  /**
   * [상점 공지사항 편집] 상점 공지사항 편집하기
   */
  EDIT_NOTICE_STORE_REQUEST: 'notice/store/EDIT_NOTICE_STORE_REQUEST',
  editNoticeStore: createAction('notice/store/EDIT_NOTICE_STORE_REQUEST'),
};

export default actions;
